import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Button, Spin, message } from "antd";
import { getCompanie } from "../../Api/Apis";
import AppConfig from "../config/AppConfig";
const { Title, Text } = Typography;

const MatchedCompanies = ({ formData, gotoPayment }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const raw = localStorage.getItem("BusinessQuestionnaireId");
      const questionnaireId = raw ? JSON.parse(raw) : null;

      if (!questionnaireId) {
        message.error("We couldn't find your request. Please re-submit the form.");
        setCompanies([]);
        return;
      }     

      const res = await getCompanie(AppConfig["entityNames"]["getCompanies"], questionnaireId);

      if (res?.success && Array.isArray(res.data)) {
        setCompanies(res.data);
        // if (res.data.length === 0) {
        //   message.info("No exact matches yet. We’ll notify you as providers join.");
        // }
      } else {
        message.error("Failed to fetch matched companies.");
      }
    } catch (e) {
      console.error("Error fetching companies:", e);
      message.error("Something went wrong while fetching matches.");
    } finally {
      setLoading(false);
    }
  };

  fetchCompanies();
}, []);


  const handleGoToPayment = () => {
    // redirect logic here (optional)
    gotoPayment();
  };

   const join = (v) => (Array.isArray(v) ? v.join(", ") : v || "—");
  const fixDash = (s) => (s || "").replace(/-/g, "-");
  const showAges = (v) =>
    Array.isArray(v) ? v.map(fixDash).join(", ") : fixDash(v) || "—";

  return (
    <Spin spinning={loading}>
      <Row justify="center" style={{ marginTop: 40 }}>
        <Col xs={24} sm={20} md={16} lg={14} xl={12} xxl={24}>
          <Card style={{ borderRadius: 12, textAlign: "center" }}>
            <Title level={2} style={{ textAlign: "center" }}>
              Thank you for completing the needs analysis form!
            </Title>
            <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 20 }}>
              We matched your answers with {companies.length} companies that can help your business.
            </Text>

            <Row gutter={[16, 16]} justify="center" style={{ marginTop: 30 }}>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Industry:</Text>
                  <div>{companies[0]?.industry?.join(", ") || "—"}</div>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Age Groups:</Text>
                  <div>{companies[0]?.ageGroup?.join(", ") || "—"}</div>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Budget:</Text>
                  <div>{companies[0]?.ranges?.join(", ") || "—"}</div>
                </Card>
              </Col>
            </Row>

            {companies.length > 0 ? 
            (<div style={{ marginTop: 30, textAlign: "center" }}>
              <Text type="secondary">To get your full report, please proceed to the payment process.</Text>
              <br />
              <Button
                type="primary"
                size="large"
                style={{ marginTop: 15, borderRadius: 20 }}
                onClick={handleGoToPayment}
              >
                Go to Payment
              </Button>
            </div>): <h3 style={{ color: 'red' }}>No Matches Found</h3>}
          </Card>

          {/* Company Cards */}
          <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
            {companies.map((company, index) => (
              <Col span={12} key={index}>
                <Card title={company.businessName} bordered hoverable style={{ borderRadius: 10 }}>
                  <Text strong>Contact Person:</Text>
                  <div>{company.contactPerson}</div>
                  <Text strong>Phone:</Text>
                  <div>{company.phoneNumber}</div>
                  <Text strong>Email:</Text>
                  <div>{company.email}</div>
                  <div style={{ marginTop: 10 }}>
                    {company.area?.map((area, idx) => (
                      <Button
                        key={idx}
                        size="small"
                        style={{
                          backgroundColor: "#1890ff",
                          color: "#fff",
                          marginRight: 6,
                          marginBottom: 6,
                          border: "none",
                          borderRadius: 12,
                        }}
                      >
                        {area}
                      </Button>
                    ))}
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Spin>
  );
};

export default MatchedCompanies;
